import ReactGA from "react-ga4";

export default function analyticEvent(category,action) {
  ReactGA.event({
    category: category,
    action: action,
  });
}

export const logEvent = (eventName, params = {}) => {
  ReactGA.event(eventName, params);
};

export const setGAUserData = (user) => {
  if (!user) return;
  let checkSubscription = user.isSubscribe || user.isSubscribeTournament || user.isSubscribeSports || user.isSubscribeBcs;
  ReactGA.set({
    user_id: user.id,
    user_plan: checkSubscription ? "Subscribed" : "Registered",
  });
};